export type ExternalLinkType = {
  label: string;
  url: string;
};

export type ExternalLinksType = ExternalLinkType[] | undefined;

export type StoreType = {
  id: number;
  prefecture: string;
  name: string;
  name_kana: string;
  postal_code: string;
  address: string;
  business_hour: string;
  tel: string;
  external_links: ExternalLinksType;
};

export type StoresInPrefectureType = {
  prefecture: string;
  stores: StoreType[];
};

// 「すべてのマイ店舗」を表すselect option用の店舗設定
export const allMyStoreType: StoreType = {
  id: -999,
  prefecture: '',
  name: 'すべてのマイ店舗',
  name_kana: '',
  postal_code: '',
  address: '',
  business_hour: '',
  tel: '',
  external_links: undefined
};
